const firebaseConfig = {
    apiKey: "AIzaSyCnIJO2c0jJ_DgI4LLw-n9y5tgIKO7NWdI",
    authDomain: "crypto-trail.firebaseapp.com",
    projectId: "crypto-trail",
    storageBucket: "crypto-trail.appspot.com",
    messagingSenderId: "872800157627",
    appId: "1:872800157627:web:f6e5cc759a65bfa922ce9e"
  };

  export default firebaseConfig;